import { useEffect } from 'react';
import { listPhotosForMantencion } from 'utils/offlinePhotosStore';

// Rehidrata las fotos pendientes (binarios persistidos en IndexedDB) de una
// (mantención, tempId) al estado controlado `pendingFiles` tras recargar o
// reabrir la app sin red. Recrea blob URLs para el preview. Cada item tiene el
// shape que consume HallazgoFotosUpload: { file, url, localId }.
//
// Multi-hallazgo: se monta por fila de hallazgo (su `tempId`). Si una foto ya se
// sincronizó, su binario fue borrado del store → no reaparece.
export function useRehydratePendingPhotos({ mantencionId, tempId, setPending }) {
  useEffect(() => {
    if (mantencionId == null || tempId == null) return undefined;
    let alive = true;
    (async () => {
      const photos = await listPhotosForMantencion(mantencionId);
      const mine = photos.filter((p) => String(p.tempId) === String(tempId));
      if (!alive || !mine.length) return;
      setPending(
        mine.map((p) => ({ file: p.blob, url: URL.createObjectURL(p.blob), localId: p.localId }))
      );
    })();
    return () => {
      alive = false;
    };
  }, [mantencionId, tempId, setPending]);
}
